import React, { useContext, useState } from 'react'

const ModuleContext = React.createContext()

export const ModuleContextProvider = ({ children, module }) => (
  <ModuleContext.Provider value={module}>{children}</ModuleContext.Provider>
)

export const useModule = () => useContext(ModuleContext)
